export const INPUT_COLOR = "rgba(77, 68, 86, 0.5)";
export const INPUT_COLOR_BORDER = "#e5e5e5";
export const NOTIFICATIONS_PANEL_BORDER = "rgba(0, 0, 0, 0.08)";
export const TASK_ALERT_PROGRESS_TRACK_BG = "rgba(0, 0, 0, 0.1)";
export const TASK_ALERT_ERROR_MESSAGE_BG = "#FEF2F3";
export const TASK_ALERT_ERROR_MESSAGE_BORDER = "#FECDD3";
export const BORDER_GRAY_COLOR = "#e4e4e4";
export const BLUE_COLOR = "#60A5FA";
export const GRAY_BACKGROUND_COLOR_CARD = "#121212";
export const GREY_OUTLINED_COLOR = "#EEE075";
export const GREY_INVOICE_PAID = "#EBEBEB";
export const TABLE_COLOR_BORDER = "#f3f4f6";
export const TABLE_COLOR_BORDER_HEADER = "#e5e7eb";

export const GREY_DISABLED_COLOR = "#757575";
export const GREY_SLIDER_COLOR = "#b7b7b7";
export const GRAY_DARK_THEME_COLOR = "#66676C";
export const GRAY_DARK_THEME_COLOR_DISABLED = "#515151";
export const GRAY_DARK_BACKGROUND_COLOR = "#171717";
export const GREEN_COLOR = "#1A8925";
export const GREEN_COLOR_LIGHT = "#48ce4b";
export const RED_COLOR = "#ff2b2b";
export const RED_LIGHT_COLOR = "#FF6759";
export const ORANGE_COLOR = "#DB7C1E";
export const APPSUMO_CHIP_TEXT_COLOR = "#EA580C";
export const APPSUMO_CHIP_BG_COLOR = "#FFEDD5";
export const RECURRENT_BADGE_MONTHLY_TEXT_COLOR = "#1D4ED8";
export const RECURRENT_BADGE_MONTHLY_BG_COLOR = "#EFF6FF";
export const RECURRENT_BADGE_MONTHLY_BORDER_COLOR = "#BFDBFE";
export const RECURRENT_BADGE_YEARLY_TEXT_COLOR = "#6D28D9";
export const RECURRENT_BADGE_YEARLY_BG_COLOR = "#F5F3FF";
export const RECURRENT_BADGE_YEARLY_BORDER_COLOR = "#DDD6FE";
/** Admin clients table — matches monthly badge layout, red tone */
export const PENDING_PAYMENT_BADGE_TEXT_COLOR = "#B91C1C";
export const PENDING_PAYMENT_BADGE_BG_COLOR = "#FEF2F2";
export const PENDING_PAYMENT_BADGE_BORDER_COLOR = "#FECACA";
/** Admin clients table — filled red chip, white label */
export const PRIORITY_BADGE_TEXT_COLOR = "#FFFFFF";
export const PRIORITY_BADGE_BG_COLOR = RED_COLOR;
export const PRIORITY_BADGE_BORDER_COLOR = RED_COLOR;
export const CREDITS_USAGE_HIGH_TEXT_COLOR = "#B91C1C";
export const CREDITS_USAGE_HIGH_BG_COLOR = "#FEF2F2";
export const CREDITS_USAGE_HIGH_BORDER_COLOR = "#FECACA";
export const CREDITS_USAGE_MEDIUM_TEXT_COLOR = "#A16207";
export const CREDITS_USAGE_MEDIUM_BG_COLOR = "#FEFCE8";
export const CREDITS_USAGE_MEDIUM_BORDER_COLOR = "#FEF08A";
export const CREDITS_USAGE_LOW_TEXT_COLOR = "#15803D";
export const CREDITS_USAGE_LOW_BG_COLOR = "#F0FDF4";
export const CREDITS_USAGE_LOW_BORDER_COLOR = "#BBF7D0";
export const WHITE_COLOR = "#FFFFFF";
export const WHITE_DARK_COLOR = "#FAFAFA";
export const DARK_LIGHT_COLOR = "#121116";
export const YELLOW_RATING = "#ffac60";
export const FUCHSIA = "rgba(177, 75, 244)";
export const FUCHSIA_BG = "rgba(177, 75, 244, 0.1)";
export const FUCHSIA_BORDER = "rgba(177, 75, 244, 0.3)";
export const FUCHSIA_LIGHT = "rgba(177, 75, 244, 0.5)";
export const WHITE_BORDER_BG_HOVER = "rgba(255, 255, 255, 0.3)";
export const WHITE_BORDER_BG_ICON = "rgba(255, 255, 255, 0.6)";
export const WHITE_LIGHT_BG_ICON = "rgba(0, 0, 0, 0.05)";

//COLORS STATISTICS
export const BAR_ORANGE_COLOR = "#FFA932";
export const BAR_BLACK_COLOR = "#171717";

// Global Colors
export const GRAY_COLOR_DISABLED = "#f3f4f6";
export const GRAY_COLOR_DISABLED_TITLE = "#4b5563";
export const GREY_COLOR = "#EDEDED";
export const GREY_DARK_COLOR = "#5b5b5b";
export const GRAY_COLOR = "#BDBDBD";
export const GRAY_COLOR_LIGHT = "#e1e1e1";
export const GRAY_COLOR_TEXT_DISABLED = "#6b7280";

// COLORS SHADCN
export const GRAY_50 = "hsl(0, 0%, 98%)"; // Muy claro
export const GRAY_100 = "hsl(0, 0%, 96.1%)";
export const GRAY_200 = "hsl(0, 0%, 89.8%)";
export const GRAY_300 = "hsl(0, 0%, 83.1%)";
export const GRAY_400 = "hsl(0, 0%, 63.9%)";
export const GRAY_500 = "hsl(0, 0%, 45.1%)";
export const GRAY_600 = "hsl(0, 0%, 32.2%)";
export const GRAY_700 = "hsl(0, 0%, 25.1%)";
export const GRAY_800 = "hsl(0, 0%, 14.9%)";
export const GRAY_900 = "hsl(0, 0%, 9%)";
export const GRAY_950 = "hsl(0, 0%, 3.9%)";

//Light Theme
//General
export const PRIMARY_COLOR = "#0A0A0A";
export const PRIMARY_COLOR_TEXT = "#050507CC";
export const SECONDARY_COLOR = "#fff";
export const SECONDARY_COLOR_TEXT = "#A1A1AA";
export const BOX_SHADOW_BUTTON = "0px 1px 2px rgba(0, 0, 0, 0.1)";
export const PAPER_BACKGROUND_COLOR = "#FFFFFF";
export const PAPER_BACKGROUND_COLOR_SLIDE_MENU = "#fafafa";
export const PAPER_CONTRAST_TEXT = PRIMARY_COLOR_TEXT;
export const PAPER_SECONDARY_BACKGROUND_COLOR = "#fff";
export const PAPER_SECONDARY_CONTRAST_TEXT = SECONDARY_COLOR_TEXT;
export const FIELD_PLACEHOLDER_COLOR = "#9f9f9f";
export const CHIP_SEARCH_COMPONENT_COLOR = "rgb(193 193 193 / 20%)";
//Inputs
export const FIELD_BACKGROUND_COLOR = "#fff";

//Buttons
export const BUTTON_BACKGROUND_COLOR = GRAY_950;
export const BUTTON_BACKGROUND_COLOR_HOVER = GRAY_800;
export const BUTTON_BACKGROUND_COLOR_DISABLED = GRAY_600;

//Dark Theme
export const PRIMARY_COLOR_DARK = "#2b2b2f";
export const PRIMARY_COLOR_TEXT_DARK = "#fff";
export const SECONDARY_COLOR_DARK = "#fdff9e";
export const SECONDARY_COLOR_TEXT_DARK = "#000";
export const DISABLED_COLOR_DARK = "#9e9e9e";
export const TABLE_HEADER_DARK = "#1e1e1e";
export const PAPER_BACKGROUND_COLOR_DARK = "#171717";
export const PAPER_CONTRAST_TEXT_DARK = "#fff";
export const PAPER_SECONDARY_BACKGROUND_COLOR_DARK = "#2b2b2f";
export const PAPER_SECONDARY_CONTRAST_TEXT_DARK = "#fff";
export const FIELD_PLACEHOLDER_COLOR_DARK = "#9f9f9f";

export const GRADIENT_YELLOW_GREEN =
  "linear-gradient(90deg, rgba(253,255,158,1) 0%, rgba(92,236,255,1) 100%)";
export const GRADIENT_PURPLE_FUCHSIA = `linear-gradient(81.02deg, rgb(250, 85, 96) -23.49%, rgb(177, 75, 244) 45.66%, rgb(77, 145, 255) 114.8%)`;
export const GRADIENT_PURPLE_FUCHSIA_COLOR_TEXT = "#fff";
export const GRADIENT_BLACK_COLOR = `linear-gradient(to bottom right, #374151, #1f2937, #111827)`;
export const BLACK_COLOR_BORDER = `#45556c`;
export const GRAY_700_HEX = "#374151"; // Color gris oscuro usado en el gradiente negro

export const GRADIENT_BLACK_COLOR_HOVER = `linear-gradient(to bottom right, #4b5563, #374151, #1f2937)`;
export const GRADIENT_BLACK_COLOR_TEXT = "#fff";

// Colores para modales y cards
export const WHITE_95_OPACITY = "rgba(255, 255, 255, 0.95)";
export const WHITE_90_OPACITY = "rgba(255, 255, 255, 0.9)";
export const GRAY_50_BG_OPACITY = "rgba(248, 250, 252, 0.5)";
export const GRAY_200_SOLID = "rgba(226, 232, 240, 1)";
export const GRAY_100_SOLID = "rgba(241, 245, 249, 1)";
export const GRAY_700_30_OPACITY = "rgba(55, 65, 81, 0.3)";
export const GRAY_700_50_OPACITY = "rgba(55, 65, 81, 0.5)";
export const BLACK_10_OPACITY = "rgba(0, 0, 0, 0.1)";
export const BLACK_12_OPACITY = "rgba(0, 0, 0, 0.12)";

// Sombras específicas
export const BOX_SHADOW_CARD = "0 1px 2px rgba(0, 0, 0, 0.1)";
export const BOX_SHADOW_CARD_HOVER = "0 20px 25px rgba(0, 0, 0, 0.1)";
export const BOX_SHADOW_BUTTON_CARD = "0 4px 6px rgba(55, 65, 81, 0.5)";
export const BOX_SHADOW_AVATAR = "0 4px 6px rgba(0, 0, 0, 0.1)";
export const BOX_SHADOW_ICON_BOX =
  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)";
export const GRADIENT_OVERLAY_CARD =
  "linear-gradient(to top, rgba(0, 0, 0, 0.1), transparent)";

export const GRADIENT_INSTAGRAM = `linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)`;
export const MAIN_COLOR_META = "#0869e1";
export const MAIN_COLOR_META_TEXT = "#fff";
export const GRADIENT_META = `linear-gradient(45deg, #0869e1 0%, #087ff3 100%)`;

export const GRADIENT_CANVA =
  "linear-gradient(90deg, rgba(10,196,207,1) 0%, rgba(123,46,237,1) 100%)";
export const COLOR_CANVA = "#FFFFFF";

export const BOX_SHADOW = "0px 0px 50px 0px rgba(0,0,0,0.1)";
export const BOX_SHADOW_FIELDS = "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
export const BOX_SHADOW_SOLID =
  "0 3px 12px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.08)";
export const BOX_SHADOW_ACTIONS_MODAL = "0px -2px 4px rgba(0, 0, 0, 0.1)";
export const BOX_SHADOW_THEME =
  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)";
export const BOX_SHADOW_CHAT =
  "0 -10px 15px -3px rgba(0,0,0,.1), 0 -4px 6px -2px rgba(0,0,0,.05)";

// A small box shadow that covers all 4 sides
export const BOX_SHADOW_LITTLE = "0px 2px 8px 0px rgba(0,0,0,0.12)";

export const COLORS_STATISTICS = ["#00BCD4", "#EF5350", "#FFBB28", "#FF8042"];

export const COLORS_BY_TYPE_STATISTIC = {
  currency: SECONDARY_COLOR_DARK,
  impressions: "hsl(30 80% 55%)",
  click: "hsl(220 76% 56%)",
  mainAction: "hsl(340 75% 55%)",
  average: "hsl(32.1 97.7% 83.1%)",
};

export const LINEAR_GRADIENT_WHITE_CARD =
  "linear-gradient(to bottom, #ffffff, #f8f9f9, #f6f6f6)";

export const LINEAR_GRADIENT_GREEN =
  "linear-gradient(to bottom right, rgba(34, 197, 94, 0.9), rgba(5, 150, 105, 0.9))";
export const LINEAR_GRADIENT_ORANGE =
  "linear-gradient(to bottom right, rgba(249, 115, 22, 0.9), rgba(220, 38, 38, 0.9))";
export const LINEAR_GRADIENT_BLUE =
  "linear-gradient(to bottom right, rgba(59, 130, 246, 0.9), rgba(79, 70, 229, 0.9))";

export const LINEAR_GRADIENT = [
  LINEAR_GRADIENT_GREEN,
  LINEAR_GRADIENT_ORANGE,
  LINEAR_GRADIENT_BLUE,
];

export const BACKGROUND_COLOR_OPTIMIZATION = "#FFF3E0";
export const TEXT_COLOR_OPTIMIZATION = "#E65100";
export const BORDER_COLOR_PDF = "#e0e0e0";

export const BUTTON_SHADOW =
  "0 0 12px 3px rgba(0, 0, 0, 0.32), 0 0 20px 6px rgba(0, 0, 0, 0.22)";
export const GRADIENT_AI_CONTENT =
  "linear-gradient(to bottom right, #8b5cf6, #a855f7, #d946ef)";
export const GRADIENT_GENERATE_ADS =
  "linear-gradient(to bottom right, #fb923c, #ec4899, #f43f5e)";
export const GRADIENT_POST_SOCIAL =
  "linear-gradient(to bottom right, #22d3ee, #3b82f6, #4f46e5)";

//CONFIG PRE-ACTIVATION
const PRE_ACTIVATION_INPUT_ROOT_SHARED_SX = {
  borderRadius: "9px !important",
  backgroundColor: WHITE_DARK_COLOR,
  "& fieldset": {
    borderRadius: "9px !important",
  },
  "&:hover fieldset": {
    borderColor: "transparent",
  },
  "&.Mui-focused fieldset": {
    borderColor: "transparent",
  },
  "&.Mui-focused": {
    backgroundColor: WHITE_COLOR,
  },
};

export const PRE_ACTIVATION_OUTLINED_INPUT_SX = {
  "& .MuiOutlinedInput-root": {
    ...PRE_ACTIVATION_INPUT_ROOT_SHARED_SX,
    "& input": {
      padding: "11px 14px",
      fontSize: "14px",
      color: PRIMARY_COLOR_TEXT,
      lineHeight: 1.5,
    },
  },
};

export const PRE_ACTIVATION_INPUT_SX_MULTILINE = {
  "& .MuiOutlinedInput-root": {
    ...PRE_ACTIVATION_INPUT_ROOT_SHARED_SX,
    padding: "0 !important",
    "& textarea.MuiInputBase-inputMultiline": {
      padding: "11px 14px",
      fontSize: "14px",
      color: PRIMARY_COLOR_TEXT,
      lineHeight: 1.5,
      boxSizing: "border-box",
      resize: "vertical",
      overflow: "auto",
    },
  },
};

export const READ_ONLY_TEXT_MAX_ROWS = 5;

export const PRE_ACTIVATION_INPUT_SX_MULTILINE_READONLY = {
  "& .MuiOutlinedInput-root": {
    ...PRE_ACTIVATION_INPUT_ROOT_SHARED_SX,
    padding: "0 !important",
    pointerEvents: "auto",
    WebkitTextFillColor: "#666666",
    color: "#666666",
    opacity: 0.9,
    "& textarea.MuiInputBase-inputMultiline": {
      padding: "11px 14px",
      fontSize: "14px",
      color: "#666666 !important",
      WebkitTextFillColor: "#666666 !important",
      lineHeight: 1.5,
      boxSizing: "border-box",
      resize: "none",
      overflowX: "hidden",
      overflowY: "auto !important",
      maxHeight: `calc(22px + 1.5 * 14px * ${READ_ONLY_TEXT_MAX_ROWS}) !important`,
      cursor: "default",
      opacity: 0.9,
    },
  },
};
